import styled from 'styled-components'

const MainNumbers = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  column-gap: 30px;
  row-gap: 20px;
`

export default MainNumbers
